import styled from "styled-components";
import colors from "../../constants/colors";

export const SelectionWrapper = styled("div")({
  marginBottom: "2rem",
});

export const MonthSelection = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
});

export const DaySelection = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "0.5rem",
});

export const TimeSlots = styled("div")({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "0.5rem",
});

export const ConfirmationSection = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const SlotSummary = styled("div")({
  // Coral gradient for attention-grabbing confirmation (complementary to purple brand)
  background: `linear-gradient(135deg, rgba(255, 127, 80, 0.3) 0%, rgba(255, 154, 102, 0.3) 100%)`,
  backdropFilter: "blur(12px) saturate(180%)",
  WebkitBackdropFilter: "blur(12px) saturate(180%)",
  borderRadius: "10px",
  padding: "0.75rem 0.875rem",
  maxWidth: "320px",
  color: colors.BLACK,
  fontSize: "0.8125rem",
  border: `2px solid ${colors.CORAL}`,
  boxShadow: `
    0px 4px 12px rgba(255, 127, 80, 0.15),
    0px 2px 6px rgba(0, 0, 0, 0.1)
  `,
  marginBottom: "1rem",
  fontFamily: "'Roboto', sans-serif",
  lineHeight: "1.4",
});
